import Section from "../../common/Section/Section";
import { EarthlySectionComponentProps } from "../../types";
import { buildScoresFields, getTotalScore } from "../../../fields/scores";
import PillarScores from "../../common/PillarScores/PillarScores";

function Scores({ details, onEdit }: EarthlySectionComponentProps) {
  const { pillars } = details;
  const totalScore = getTotalScore(pillars);

  return (
    <Section
      title="Scores"
      columns={2}
      fields={buildScoresFields(pillars)}
      onEdit={() => onEdit("scores")}
      reference={[
        {
          type: "component",
          place: "beneath",
          index: 0,
          item: <PillarScores pillars={pillars} totalScore={totalScore} />,
        },
      ]}
    />
  );
}

export default Scores;
